/* ============================================================================
   Caffeine content database for the bedtime calculator.

   DATA ONLY. No logic lives here, so the list can be edited without reading a
   line of app code. assets/unc-calc.js is the only consumer.

   Source: Tim's export from a personal caffeine-tracking app, supplied
   01 Aug 2026. Its own header says the values are "as recorded in that app, not
   independently re-verified against manufacturer data", so THE PAGE CARRIES A
   VISIBLE FOOTNOTE saying figures are indicative. Do not present these as
   manufacturer figures anywhere.

   EXCEPTION, 4 Oct 2026: the UK high-street chain rows (Caffè Nero, Costa,
   Greggs, Pret, Starbucks) were re-checked against the chains' own 2026
   guides and Which? (25 Aug 2026), and the source is cited above each block.
   Full sourced list: 00 Claude HQ/agents/blog/work/uk-high-street-coffee/
   research-log.md (working folder). Rows with a size in the name exist
   because the calculator looks drinks up by name, so names must be unique.

   EXCEPTION, 8 Oct 2026: three rows match official figures so the page agrees
   with our reels: Monster Energy 160 (UK 500 ml can label, 32mg/100ml),
   Coca-Cola 34 (Coca-Cola GB, 330 ml can), Tea (Black) 75 a mug (NHS: "75mg
   in a cup of tea"). The Tea tile is a cup per tap, so the NHS cup figure fits.

   Fields are one letter each because this ships to every visitor of the page:
     n  name        mg  caffeine in milligrams
     s  serving     c   category

   CATEGORIES ARE BY WHAT YOU ORDER, NOT BY WHAT IS IN THE CUP. A named
   chain drink sits under Chain, so browsing Coffee gives you a plain
   americano rather than nine variants of a Nero. Energy drinks are left
   whole: that category is branded by nature and splitting it empties it.

   Rows deliberately NOT shipped, and why:
     Solo Energy Drink: source says '32 mg | 1 ml', which is not a serving. No trustworthy value to substitute.
     Caffeine powder: 1000mg in one tap. Caffeine powder overdose is a documented cause of death and this is a consumer tool.

   Known noise left in on purpose: dark chocolate 60-69% reads 9mg against
   70-85% at 8mg, which is backwards. Harmless at that magnitude and correcting
   it would mean inventing a number.
   ============================================================================ */
window.UNC_CAFFEINE_DB = [
  { n: "Americano", mg: 77, s: "1 shot", c: "Coffee" },
  { n: "Atkins Iced Coffee Protein Shake", mg: 70, s: "1 cup", c: "Chain" },
  { n: "Caffè Latte", mg: 77, s: "1 cup", c: "Coffee" },
  /* Caffè Nero: Which? press release, 25 Aug 2026 (figures stated by the chain,
     sizes in ml as Which? lists them). Nero's own GB guide (09/09/26) has no
     caffeine column. Con panna and macchiato are the same single espresso.
     Frappe, iced and mocha rows are the older app values: no 2026 source. */
  { n: "Caffé Nero Americano", mg: 191, s: "1 cup (355 ml)", c: "Chain" },
  { n: "Caffé Nero Caffé Latte", mg: 105, s: "1 cup (237 ml)", c: "Chain" },
  { n: "Caffé Nero Cappuccino", mg: 221, s: "1 cup (355 ml)", c: "Chain" },
  { n: "Caffé Nero Espresso", mg: 67, s: "1 shot", c: "Chain" },
  { n: "Caffé Nero Espresso Con Panna", mg: 67, s: "1 shot", c: "Chain" },
  { n: "Caffé Nero Espresso Macchiato", mg: 67, s: "1 shot", c: "Chain" },
  { n: "Caffé Nero Flat White", mg: 105, s: "1 cup (237 ml)", c: "Chain" },
  { n: "Caffé Nero Frappe Latte", mg: 160, s: "1 cup (medium)", c: "Chain" },
  { n: "Caffé Nero Iced Latte", mg: 160, s: "1 cup (medium)", c: "Chain" },
  { n: "Caffé Nero Mocha", mg: 170, s: "1 cup (medium)", c: "Chain" },
  { n: "Caffé Nero Mocha Frappe Latte", mg: 170, s: "1 cup (medium)", c: "Chain" },
  { n: "Cappuccino", mg: 77, s: "1 cup", c: "Coffee" },
  { n: "Cappuccino – Double", mg: 143, s: "1 cup", c: "Coffee" },
  /* Costa: own guide "Costa information on caffeine, autumn 2026" (UK store
     allergen guide, linked from costa.co.uk/sustainability/nutrition, p3).
     Signature Blend: 1 shot 100, 2 shots 200, 3 shots 325, 4 shots 400 mg.
     Shots: latte small drink-in 1, small takeaway 2, medium 2, large 3;
     americano and cappuccino small 2, medium 3, large 4. Flat white is
     3 cortissimo shots, 241 mg, one size. */
  { n: "Costa Americano", mg: 200, s: "1 cup (small)", c: "Chain" },
  { n: "Costa Americano (medium)", mg: 325, s: "1 cup (medium)", c: "Chain" },
  { n: "Costa Cappuccino", mg: 200, s: "1 cup (small)", c: "Chain" },
  { n: "Costa Cappuccino (medium)", mg: 325, s: "1 cup (medium)", c: "Chain" },
  { n: "Costa Espresso", mg: 100, s: "1 shot", c: "Chain" },
  { n: "Costa Flat White", mg: 241, s: "1 cup", c: "Chain" },
  { n: "Costa Latte", mg: 100, s: "1 cup (small, drink in)", c: "Chain" },
  { n: "Costa Latte (small takeaway)", mg: 200, s: "1 cup (small takeaway)", c: "Chain" },
  { n: "Costa Latte (medium)", mg: 200, s: "1 cup (medium)", c: "Chain" },
  { n: "Decaf instant coffee", mg: 2, s: "1 teaspoon", c: "Coffee" },
  { n: "Drip coffee", mg: 95, s: "1 cup", c: "Coffee" },
  { n: "Dunkin' Americano", mg: 237, s: "1 cup (small)", c: "Chain" },
  { n: "Dunkin' Cappuccino", mg: 166, s: "1 cup (medium)", c: "Chain" },
  { n: "Dunkin' Dunkaccino", mg: 85, s: "1 cup (medium)", c: "Chain" },
  { n: "Dunkin' Espresso", mg: 118, s: "1 shot", c: "Chain" },
  { n: "Dunkin' Iced Latte", mg: 166, s: "1 cup (medium)", c: "Chain" },
  { n: "Dunkin' Iced Macchiato", mg: 284, s: "1 cup (medium)", c: "Chain" },
  { n: "Dunkin' Latte", mg: 166, s: "1 cup (medium)", c: "Chain" },
  { n: "Dunkin' Macchiato", mg: 237, s: "1 cup (small)", c: "Chain" },
  { n: "Espresso", mg: 77, s: "1 shot", c: "Coffee" },
  /* Greggs: Which? press release, 25 Aug 2026 (stated by the chain; no Greggs
     guide with caffeine found). Sizes as Which? lists them. */
  { n: "Greggs Americano", mg: 257, s: "1 cup (382 ml)", c: "Chain" },
  { n: "Greggs Cappuccino", mg: 235, s: "1 cup (327 ml)", c: "Chain" },
  { n: "Greggs Espresso", mg: 75, s: "1 shot", c: "Chain" },
  { n: "Greggs Flat White", mg: 150, s: "1 cup (222 ml)", c: "Chain" },
  { n: "Greggs Latte", mg: 150, s: "1 cup (222 ml)", c: "Chain" },
  { n: "Hell Ice Coffee", mg: 38, s: "1 cup", c: "Chain" },
  { n: "Instant Coffee", mg: 57, s: "1 teaspoon", c: "Coffee" },
  { n: "K-Cup", mg: 80, s: "1 pod", c: "Chain" },
  { n: "Kirkland Breakfast Blend", mg: 98, s: "1 cup", c: "Chain" },
  { n: "Kopi Peng", mg: 95, s: "1 cup", c: "Coffee" },
  { n: "McCafé Americano", mg: 71, s: "1 cup (small)", c: "Chain" },
  { n: "McCafé Cappuccino", mg: 71, s: "1 cup (small)", c: "Chain" },
  { n: "McCafé Caramel Cappuccino", mg: 71, s: "1 cup (small)", c: "Chain" },
  { n: "McCafé Caramel Macchiato", mg: 71, s: "1 cup (small)", c: "Chain" },
  { n: "McCafé Latte", mg: 71, s: "1 cup (small)", c: "Chain" },
  { n: "McCafé Mocha", mg: 86, s: "1 cup (small)", c: "Chain" },
  { n: "Merrild Red", mg: 96, s: "1 cup", c: "Chain" },
  { n: "Merrild Special", mg: 95, s: "1 cup", c: "Chain" },
  { n: "Nescafé 3 in 1 Instant Coffee", mg: 50, s: "1 packet", c: "Chain" },
  { n: "Nescafé Classic", mg: 75, s: "1 teaspoon", c: "Chain" },
  { n: "Nescafé Dolce Gusto – Caffe Grande Intenso", mg: 130, s: "1 pod", c: "Chain" },
  { n: "Nescafé Dolce Gusto – Café Au Lait", mg: 92, s: "1 pod", c: "Chain" },
  { n: "Nescafé Dolce Gusto – Café Au Lait Intenso", mg: 102, s: "1 pod", c: "Chain" },
  { n: "Nescafé Dolce Gusto – Capuccino", mg: 107, s: "1 pod", c: "Chain" },
  { n: "Nescafé Dolce Gusto – Capuccino Skinny", mg: 90, s: "1 pod", c: "Chain" },
  { n: "Nescafé Dolce Gusto – Espresso", mg: 80, s: "1 pod", c: "Chain" },
  { n: "Nescafé Dolce Gusto – Espresso Intenso", mg: 115, s: "1 pod", c: "Chain" },
  { n: "Nescafé Dolce Gusto – Latte Macchiato", mg: 85, s: "1 pod", c: "Chain" },
  { n: "Nescafé Dolce Gusto – Lungo", mg: 89, s: "1 pod", c: "Chain" },
  { n: "Nescafé Dolce Gusto – Lungo Intenso", mg: 147, s: "1 pod", c: "Chain" },
  { n: "Nescafé Gold", mg: 44, s: "1 teaspoon", c: "Chain" },
  { n: "Nescafé Ice Java", mg: 60, s: "1 tablespoon", c: "Chain" },
  { n: "Nespresso Classic Pod (110 ml)", mg: 95, s: "1 cup", c: "Chain" },
  { n: "Nespresso Classic Pod (25 ml)", mg: 60, s: "1 pod", c: "Chain" },
  { n: "Nespresso Classic Pod (40 ml)", mg: 80, s: "1 pod", c: "Chain" },
  { n: "Nespresso Vertuo Pod (150 ml)", mg: 150, s: "1 pod", c: "Chain" },
  { n: "Nespresso Vertuo Pod (230 ml)", mg: 177, s: "1 cup", c: "Chain" },
  { n: "Nespresso Vertuo Pod (230 ml, +20% Caffeine)", mg: 200, s: "1 pod", c: "Chain" },
  { n: "Nespresso Vertuo Pod (25 ml)", mg: 60, s: "1 pod", c: "Chain" },
  { n: "Nespresso Vertuo Pod (40 ml)", mg: 60, s: "1 pod", c: "Chain" },
  { n: "Old Town White coffee", mg: 60, s: "1 cup", c: "Chain" },
  { n: "Peter Larsen Kaffe Fairtrade", mg: 95, s: "1 cup", c: "Chain" },
  { n: "Peter Larsen Kaffe Original 72", mg: 95, s: "1 cup", c: "Chain" },
  /* Starbucks UK: own Summer 2026 core beverage allergen book (v 28/04/26).
     Espresso 44.6 mg a shot. Tall (12 oz) = 2 shots = 89.1 mg; a grande latte
     or cappuccino is still 89.1, a grande americano 133.7. Mocha tall 107.3.
     Flat white is Short only. White mocha: the book lists the iced one, tall
     89.1. Cold brew grande 264.7. Filter: Which?, 25 Aug 2026 (tall, 354 ml). */
  /* Pret: Which? press release, 25 Aug 2026 (stated by the chain; Pret publishes
     no caffeine figures of its own that we found). Sizes as Which? lists them. */
  { n: "Pret Americano", mg: 180, s: "1 cup (355 ml)", c: "Chain" },
  { n: "Pret Cappuccino", mg: 180, s: "1 cup (355 ml)", c: "Chain" },
  { n: "Pret Espresso", mg: 180, s: "1 cup (50 ml)", c: "Chain" },
  { n: "Pret Filter Coffee", mg: 271, s: "1 cup (355 ml)", c: "Chain" },
  { n: "Pret Flat White", mg: 180, s: "1 cup (237 ml)", c: "Chain" },
  { n: "Pret Latte", mg: 180, s: "1 cup (237 ml)", c: "Chain" },
  { n: "Starbucks Americano", mg: 89, s: "1 cup (tall)", c: "Chain" },
  { n: "Starbucks Americano (grande)", mg: 134, s: "1 cup (grande)", c: "Chain" },
  { n: "Starbucks Caffe Latte", mg: 89, s: "1 cup (tall)", c: "Chain" },
  { n: "Starbucks Café Mocha", mg: 107, s: "1 cup (tall)", c: "Chain" },
  { n: "Starbucks Cappuccino", mg: 89, s: "1 cup (tall)", c: "Chain" },
  { n: "Starbucks Caramel Macchiato", mg: 89, s: "1 cup (tall)", c: "Chain" },
  { n: "Starbucks Cold Brew", mg: 265, s: "1 cup (grande)", c: "Chain" },
  { n: "Starbucks Espresso", mg: 45, s: "1 shot", c: "Chain" },
  { n: "Starbucks Filter Coffee", mg: 210, s: "1 cup (tall)", c: "Chain" },
  { n: "Starbucks Flat White", mg: 89, s: "1 cup (short)", c: "Chain" },
  { n: "Starbucks Iced Caffè Latte", mg: 89, s: "1 cup (tall)", c: "Chain" },
  { n: "Starbucks White Mocha", mg: 89, s: "1 cup (tall)", c: "Chain" },
  { n: "Suntory Boss Iced Long Black", mg: 140, s: "1 can", c: "Chain" },
  { n: "Turkish Coffee", mg: 51, s: "1 cup (small)", c: "Coffee" },
  { n: "28 Black Energy Drink", mg: 125, s: "1 can", c: "Energy" },
  { n: "3D Energy", mg: 200, s: "1 can", c: "Energy" },
  { n: "5 Hour Energy Extra Strength", mg: 230, s: "1 shot", c: "Energy" },
  { n: "Bang Energy Drink", mg: 300, s: "1 can", c: "Energy" },
  { n: "Big Shock!", mg: 115, s: "1 can", c: "Energy" },
  { n: "Burn", mg: 114, s: "1 can", c: "Energy" },
  { n: "C4 Energy drink", mg: 200, s: "1 can", c: "Energy" },
  { n: "Carabao Energy Drink", mg: 106, s: "1 can", c: "Energy" },
  { n: "Celsius Blood Orange Lemonade", mg: 100, s: "1 can", c: "Energy" },
  { n: "Celsius Inferno Punch", mg: 300, s: "1 can", c: "Energy" },
  { n: "Celsius Jackfruit", mg: 300, s: "1 can", c: "Energy" },
  { n: "Celsius Peach Mango Green Tea", mg: 200, s: "1 can", c: "Energy" },
  { n: "Celsius Sparkling Grapefruit", mg: 200, s: "1 can", c: "Energy" },
  { n: "Celsius Sparkling Orange", mg: 200, s: "1 can", c: "Energy" },
  { n: "Celsius Sparkling Watermelon", mg: 200, s: "1 can", c: "Energy" },
  { n: "Celsius Tart Cherry Lime", mg: 100, s: "1 can", c: "Energy" },
  { n: "Eternal Energy", mg: 190, s: "1 shot", c: "Energy" },
  { n: "Fast Twitch", mg: 200, s: "1 bottle", c: "Energy" },
  { n: "Full Throttle", mg: 160, s: "1 can", c: "Energy" },
  { n: "Gamersups", mg: 100, s: "1 cup", c: "Energy" },
  { n: "Ghost", mg: 200, s: "1 can", c: "Energy" },
  { n: "Gorgie", mg: 120, s: "1 can", c: "Energy" },
  { n: "Gorilla Mind Energy Drink", mg: 200, s: "1 can", c: "Energy" },
  { n: "Gorilla Mode Pre-workout", mg: 350, s: "1 cup", c: "Energy" },
  { n: "Guarana", mg: 160, s: "1 can", c: "Energy" },
  { n: "Hell Energy Drink", mg: 80, s: "1 can", c: "Energy" },
  { n: "Jocko GO", mg: 95, s: "1 can", c: "Energy" },
  { n: "Lucky Energy", mg: 80, s: "1 can", c: "Energy" },
  { n: "Mio Energy", mg: 60, s: "1 cup", c: "Energy" },
  { n: "Monster Energy", mg: 160, s: "1 can (500 ml)", c: "Energy" },
  { n: "Monster Energy Assault", mg: 160, s: "1 can", c: "Energy" },
  { n: "Monster Energy Import", mg: 179, s: "1 can", c: "Energy" },
  { n: "Monster Energy Java", mg: 200, s: "1 can", c: "Energy" },
  { n: "Monster Energy Java 300", mg: 300, s: "1 can", c: "Energy" },
  { n: "Monster Energy Juice", mg: 160, s: "1 can", c: "Energy" },
  { n: "Monster Energy Mango Loco", mg: 150, s: "1 can", c: "Energy" },
  { n: "Monster Energy Mega Drink", mg: 240, s: "1 can", c: "Energy" },
  { n: "Monster Energy Mule", mg: 160, s: "1 can", c: "Energy" },
  { n: "Monster Energy Nitro", mg: 160, s: "1 can", c: "Energy" },
  { n: "Monster Energy Pipeline Punch", mg: 160, s: "1 can", c: "Energy" },
  { n: "Monster Energy Rehab", mg: 160, s: "1 can", c: "Energy" },
  { n: "Monster Energy Reserve", mg: 160, s: "1 can", c: "Energy" },
  { n: "Monster Energy Ultra", mg: 150, s: "1 can", c: "Energy" },
  { n: "Monster Energy Ultra Black", mg: 140, s: "1 can", c: "Energy" },
  { n: "Monster Energy Ultra Blue", mg: 150, s: "1 can", c: "Energy" },
  { n: "Monster Energy Ultra Fiesta", mg: 150, s: "1 can", c: "Energy" },
  { n: "Monster Energy Ultra Gold", mg: 150, s: "1 can", c: "Energy" },
  { n: "Monster Energy Ultra Paradise", mg: 140, s: "1 can", c: "Energy" },
  { n: "Monster Energy Ultra Peachy Keen", mg: 150, s: "1 can", c: "Energy" },
  { n: "Monster Energy Ultra Red", mg: 140, s: "1 can", c: "Energy" },
  { n: "Monster Energy Ultra Rosa", mg: 150, s: "1 can", c: "Energy" },
  { n: "Monster Energy Ultra Sunrise", mg: 155, s: "1 can", c: "Energy" },
  { n: "Monster Energy Ultra Violet", mg: 140, s: "1 can", c: "Energy" },
  { n: "Monster Energy Ultra Watermelon", mg: 150, s: "1 can", c: "Energy" },
  { n: "Monster Energy Zero Sugar", mg: 160, s: "1 can", c: "Energy" },
  { n: "Mountain Dew Kickstart", mg: 90, s: "1 can", c: "Energy" },
  { n: "Nocco BCAA", mg: 180, s: "1 can", c: "Energy" },
  { n: "Nocco Focus", mg: 180, s: "1 can", c: "Energy" },
  { n: "Oca", mg: 120, s: "1 can", c: "Energy" },
  { n: "Prime Energy Drink", mg: 200, s: "1 can", c: "Energy" },
  { n: "Red Bull", mg: 80, s: "1 can", c: "Energy" },
  { n: "Red Bull Blue Edition", mg: 80, s: "1 can", c: "Energy" },
  { n: "Red Bull Coconut Edition", mg: 80, s: "1 can", c: "Energy" },
  { n: "Red Bull Green Edition", mg: 80, s: "1 can", c: "Energy" },
  { n: "Red Bull Peach Edition", mg: 80, s: "1 can", c: "Energy" },
  { n: "Red Bull Red Edition", mg: 80, s: "1 can", c: "Energy" },
  { n: "Red Bull Sugarfree", mg: 80, s: "1 can", c: "Energy" },
  { n: "Red Bull Summer Edition", mg: 80, s: "1 can", c: "Energy" },
  { n: "Red Bull Tropical Edition", mg: 80, s: "1 can", c: "Energy" },
  { n: "Red Bull Winter Edition", mg: 80, s: "1 can", c: "Energy" },
  { n: "Red Bull Zero", mg: 80, s: "1 can", c: "Energy" },
  { n: "Reign (UK)", mg: 200, s: "1 can", c: "Energy" },
  { n: "Reign (US)", mg: 300, s: "1 can", c: "Energy" },
  { n: "Rip It Citrus X", mg: 160, s: "1 can", c: "Energy" },
  { n: "Semtex", mg: 114, s: "1 can", c: "Energy" },
  { n: "Tiger", mg: 160, s: "1 can", c: "Energy" },
  { n: "True North Home", mg: 120, s: "1 can", c: "Energy" },
  { n: "Twist Energy Drink", mg: 80, s: "1 can", c: "Energy" },
  { n: "V8+ Energy Black Cherry", mg: 80, s: "1 can", c: "Energy" },
  { n: "V8+ Energy Diet Cranberry Raspberry", mg: 80, s: "1 can", c: "Energy" },
  { n: "V8+ Energy Diet Strawberry Lemonade", mg: 80, s: "1 can", c: "Energy" },
  { n: "V8+ Energy Honeycrisp Apple Berry", mg: 80, s: "1 can", c: "Energy" },
  { n: "V8+ Energy Orange Pineapple", mg: 80, s: "1 can", c: "Energy" },
  { n: "V8+ Energy Peach Mango", mg: 80, s: "1 can", c: "Energy" },
  { n: "V8+ Energy Pomegranate Blueberry", mg: 80, s: "1 can", c: "Energy" },
  { n: "V8+ Energy Sparkling Black Cherry", mg: 80, s: "1 can", c: "Energy" },
  { n: "V8+ Energy Sparkling Lemon Lime", mg: 80, s: "1 can", c: "Energy" },
  { n: "V8+ Energy Sparkling Orange Pineapple", mg: 80, s: "1 can", c: "Energy" },
  { n: "V8+ Energy Sparkling Strawberry Kiwi", mg: 80, s: "1 can", c: "Energy" },
  { n: "V8+ Energy Strawberry Banana", mg: 80, s: "1 can", c: "Energy" },
  { n: "V8+ Energy Tropical Green", mg: 80, s: "1 can", c: "Energy" },
  { n: "Wooooo! Energy Drink", mg: 200, s: "1 can", c: "Energy" },
  { n: "Cheerwine", mg: 48, s: "1 can", c: "Soft" },
  { n: "Cheerwine Diet", mg: 48, s: "1 can", c: "Soft" },
  { n: "Coca-Cola", mg: 34, s: "1 can (330 ml)", c: "Soft" },
  { n: "Coca-Cola Cherry", mg: 34, s: "1 can", c: "Soft" },
  { n: "Coca-Cola Diet Cherry", mg: 35, s: "1 can", c: "Soft" },
  { n: "Coca-Cola Light", mg: 46, s: "1 can", c: "Soft" },
  { n: "Coca-Cola Zero", mg: 32, s: "1 can", c: "Soft" },
  { n: "Crystal Light", mg: 30, s: "1 cup", c: "Soft" },
  { n: "Diet Coke", mg: 46, s: "1 can", c: "Soft" },
  { n: "Dr. Pepper", mg: 42, s: "1 can", c: "Soft" },
  { n: "Faygo Cola", mg: 42, s: "1 can", c: "Soft" },
  { n: "Kofola", mg: 53, s: "1 can", c: "Soft" },
  { n: "Mountain Dew", mg: 54, s: "1 can", c: "Soft" },
  { n: "Mountain Dew Code Red", mg: 54, s: "1 can", c: "Soft" },
  { n: "Paulaner Spezi", mg: 33, s: "1 bottle", c: "Soft" },
  { n: "Pepsi", mg: 38, s: "1 can", c: "Soft" },
  { n: "Pepsi Cherry", mg: 40, s: "1 can", c: "Soft" },
  { n: "Pepsi Diet Cherry", mg: 41, s: "1 can", c: "Soft" },
  { n: "Pepsi Max", mg: 46, s: "1 can", c: "Soft" },
  { n: "Shasta Cola", mg: 43, s: "1 can", c: "Soft" },
  { n: "Dunkin' Hot Tea", mg: 90, s: "1 cup (medium)", c: "Chain" },
  { n: "Dunkin' Iced Tea", mg: 67, s: "1 cup (medium)", c: "Chain" },
  { n: "Dunkin' Matcha Latte", mg: 90, s: "1 cup (medium)", c: "Chain" },
  { n: "Dunkin' Vanilla Chai", mg: 80, s: "1 cup (medium)", c: "Chain" },
  { n: "Fuze Tea", mg: 12, s: "1 can", c: "Chain" },
  { n: "Green Tea", mg: 34, s: "1 cup", c: "Tea" },
  { n: "Guayakí Yerba Mate", mg: 150, s: "1 can", c: "Chain" },
  { n: "Irish Tea", mg: 50, s: "1 cup", c: "Tea" },
  { n: "Lipton Iced Tea", mg: 15, s: "1 can", c: "Chain" },
  { n: "Matcha Tea", mg: 64, s: "1 teaspoon", c: "Tea" },
  { n: "Nestea", mg: 16, s: "1 can", c: "Chain" },
  { n: "Tea (Black)", mg: 75, s: "1 mug", c: "Tea" },
  { n: "Tea (Green)", mg: 36, s: "1 teabag", c: "Tea" },
  { n: "Tea (Herbal)", mg: 0, s: "1 teabag", c: "Tea" },
  { n: "Tea (Jasmine)", mg: 25, s: "1 teabag", c: "Tea" },
  { n: "Yerba Maté (Tea)", mg: 40, s: "1 cup", c: "Tea" },
  { n: "Dark Chocolate (45-59%)", mg: 4, s: "1 piece", c: "Chocolate" },
  { n: "Dark Chocolate (60-69%)", mg: 9, s: "1 piece", c: "Chocolate" },
  { n: "Dark Chocolate (70-85%)", mg: 8, s: "1 piece", c: "Chocolate" },
  { n: "Dunkin' Hot Chocolate", mg: 13, s: "1 cup (medium)", c: "Chain" },
  { n: "Hot Cocoa", mg: 8, s: "1 cup", c: "Chocolate" },
  { n: "Swiss Miss Hot Chocolate", mg: 6, s: "1 packet", c: "Chain" },
  { n: "Excedrin", mg: 65, s: "1 pill", c: "Pills" },
  { n: "Generic Caffeine Pill", mg: 200, s: "1 pill", c: "Pills" },
  { n: "Jet Alert Caffeine Pill", mg: 100, s: "1 pill", c: "Pills" },
  { n: "MADMONQ", mg: 155, s: "1 pill", c: "Pills" },
  { n: "NoDoz Caffeine Pill", mg: 200, s: "1 pill", c: "Pills" },
  { n: "Vivarin", mg: 200, s: "1 pill", c: "Pills" },
  { n: "Huel Daily", mg: 100, s: "1 can", c: "Energy" },
  { n: "Huel Ice Latte", mg: 95, s: "1 can", c: "Other" },
];
